import { Component, Input } from '@angular/core';
import {
  type FormGroupControls,
  FormGroupState,
  NgrxFormsModule,
} from 'ngrx-forms';
import {
  DropdownComponent,
  InputErrorComponent,
} from '@innogy/common-ui/forms';
import {
  TrackStepDirective,
  TrackValueChangeDirective,
} from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { AnalyticsMapPipe, IsInvalidPipe } from '@innogy/utils-deprecated';

import { UsageQuestionnaireProps } from './usage-questionnaire.model';
import type { UsageQuestionnaireFormValues } from './state/usage-questionnaire.reducer';

@Component({
  selector: 'wl-usage-questionnaire',
  templateUrl: './usage-questionnaire.component.html',
  standalone: true,
  imports: [
    AutomationIdDirective,
    IsInvalidPipe,
    AnalyticsMapPipe,
    DropdownComponent,
    TrackValueChangeDirective,
    InputErrorComponent,
    NgrxFormsModule,
    TrackStepDirective,
  ],
})
export class UsageQuestionnaireComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true })
  formState!: FormGroupState<UsageQuestionnaireFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: UsageQuestionnaireProps;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() gasHidden = false;

  get formControls(): FormGroupControls<UsageQuestionnaireFormValues> {
    return this.formState.controls;
  }

  get energyTypeDropdownShown(): boolean {
    return (
      this.formState.userDefinedProperties['supplyTypeRequired'] &&
      !this.gasHidden
    );
  }
}
